import chalk from "chalk";

export const sleep = async (ms = 250) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

const getPrettyBoolean = (value: boolean) => chalk[value ? "green" : "red"];

export const prettyBoolean = (value: boolean) => {
    const colorizer = getPrettyBoolean(value);
    return colorizer(value);
};

export const prettyBooleanText = (text: string, value: boolean) => {
    return getPrettyBoolean(value)(text);
};

export const prettyNumber = (value: number) => chalk.yellow(value);
